import { create } from "zustand";
import { createIntl as internal_createIntl, createIntlCache } from "react-intl";
import type { IntlShape } from "react-intl";
import type { Locale } from "@/types/global";
import { getIntlMessages, setAntdLocale } from "@/utils/intlUtils";

export interface IntlStore {
  locale: Locale;
  intl: IntlShape;
  createIntl: (locale: Locale) => void;
}

const initIntlInstance = () => {
  const cache = createIntlCache();

  const intl = internal_createIntl(
    {
      locale: "zh-CN",
      messages: getIntlMessages("zh-CN"),
    },
    cache,
  );

  return intl;
};

const useIntlStore = create<IntlStore>((set) => ({
  locale: "zh-CN" as Locale,
  intl: initIntlInstance(),
  createIntl: (locale) => {
    const cache = createIntlCache();

    const intl = internal_createIntl(
      {
        locale,
        messages: getIntlMessages(locale),
      },
      cache,
    );
    setAntdLocale(locale);
    set({ intl, locale });
  },
}));

export default useIntlStore;
